import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getTransporterList = (page, pagesize, search, ordering,signal) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/transporter/', {
        headers: authHeader(), params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        },
        signal, 
    });
};

const getTransporterListByDieId = (dieId, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/transporter/', {
    
        
        headers: authHeader(), params: {
            die: dieId,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getArchiveTransporterList = (page, pagesize, search, ordering,signal) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/transporter-archive', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
        ,signal,
    });
};

const getTransporterDetails = (dieId) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/transporter-details/', {
        headers: authHeader(), params: {
            die: dieId
        }
    });
};


const getTransporterById = (id) => {
    return axios.get(API_URL + '/api/' + API_VERSION + `/transporter/${id}`, {
        headers: authHeader(), 
        // params: {
        //     id: id
        // }
    });
};
const addTransporter = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/transporter/`,
        formData, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const updateTransporter = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/transporter/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const deleteTransporter = (id) => {
   
    return axios.delete(
        `${API_URL}/api/${API_VERSION}/transporter/${id}/`,
        { headers: authHeader() }, // Authentication header
      );
};

const unArchiveTransporterRecord = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/transporter/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const transporterService = {
    getTransporterList,
    getTransporterListByDieId,
    getArchiveTransporterList,
    getTransporterDetails,
    getTransporterById,
    addTransporter,
    updateTransporter,
    deleteTransporter,
    unArchiveTransporterRecord
};

export default transporterService;
